import { Group, Text, UnstyledButton } from "@mantine/core";

/**
 * A date with its weekday beside it, as the first column of a per-day summary
 * table. With `onClick`, the whole cell is the hit target for opening that
 * day; without (a value that would not parse, so there is no day to open) it
 * stays inert and the weekday is left blank.
 */
const DateWeekdayCell = ({
  ariaLabel,
  label,
  onClick,
  weekday,
}: {
  ariaLabel: string;
  label: string;
  onClick?: () => void;
  weekday: string;
}) => {
  const content = (
    // Side by side, wrapping to a second line only when the column is too
    // narrow to hold both.
    <Group gap={6} align="baseline" wrap="wrap">
      <Text size="sm">{label}</Text>
      {weekday !== "" && (
        <Text size="xs" c="dimmed">
          {weekday}
        </Text>
      )}
    </Group>
  );

  if (!onClick) return content;

  // Fills the cell so the whole width is the hit target, and inherits the
  // cell's own typography — the date reads exactly as it does elsewhere.
  return (
    <UnstyledButton
      aria-label={ariaLabel}
      onClick={onClick}
      style={{ cursor: "pointer", display: "block", width: "100%" }}
    >
      {content}
    </UnstyledButton>
  );
};

export default DateWeekdayCell;
